import { useMemo } from 'react';
import { useFetch } from '../hooks/useFetch';
import {
  addQuestion,
  createChat,
  getChats,
  getHistory,
  updateChat,
} from './chat';

export const useChatApi = () => {
  const { fetchInstance } = useFetch();

  const chatAPI = useMemo(() => ({
    createChat: async (chatName) => createChat(chatName, fetchInstance),
    getChats: async () => getChats(fetchInstance),
    addQuestion: async (props) => addQuestion(props, fetchInstance),
    getHistory: async (chatId) => getHistory(chatId, fetchInstance),
    updateChat: async (chatId, props) => updateChat(chatId, props, fetchInstance),
  }), [fetchInstance]);

  return chatAPI;
};

export default useChatApi;
